import type { FileEditSchemaEditPayload } from '@repo/schemas/file/fileEdit';
import type { FilePermissions, FilePrivate } from '@repo/types/files';
import type { AxiosProgressEvent, AxiosResponse } from 'axios';

import { axiosInstance } from '#api-client';
export class FileService {
  static async getFile(id?: string): Promise<AxiosResponse<FilePrivate>> {
    return await axiosInstance.get(`/api/fs/file/${id}`);
  }

  static async getFilePermissions(id?: string): Promise<AxiosResponse<FilePermissions>> {
    return await axiosInstance.get(`/api/fs/file/${id}/getPermissions`);
  }

  static async uploadFile(data: FileUploadData): Promise<AxiosResponse<FilePrivate>> {
    const { directoryId, file, abortController, progressCallBack } = data;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('directoryId', directoryId);
    return await axiosInstance.post('/api/fs/file', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (progressEvent: AxiosProgressEvent) => {
        progressCallBack?.(progressEvent);
      },
      signal: abortController?.signal,
    });
  }

  static async editFile(data: FileEditSchemaEditPayload): Promise<AxiosResponse<FilePrivate>> {
    const { id, ...rest } = data;
    return await axiosInstance.put(`/api/fs/file/${id}`, rest);
  }

  static async deleteFile(id: string): Promise<AxiosResponse<string>> {
    return await axiosInstance.delete(`/api/fs/file/${id}`);
  }
}

export interface FileUploadData {
  directoryId: string;
  file: File;
  tempUUID?: string;
  progressCallBack?: (progressEvent: AxiosProgressEvent) => void;
  abortController?: AbortController;
}
